import React from 'react'

import * as firebase from 'firebase'

import { connect } from 'react-redux'

import moment from 'moment'

import PhotoItem from './PhotoItem'
import PhotosAddItem from './PhotosAddItem'
import JobModuleBase from '../JobModuleBase'
import AllPhotosScreen from './AllPhotosScreen'
import PhotoSlideShow from 'common/PhotoSlideShow/SlideShow'

class PhotosModule extends JobModuleBase {

  constructor(props) {
    super(props)
    this.state = {
      photos: [],
      fullscreenVisible: false,
      selectedIdx: 0
    }
    this.isSingleDay = !props.jobInfo.modules.date.recurrence
        && props.jobInfo.modules.date.startDate === props.jobInfo.modules.date.endDate
  }

  componentWillMount() {
    // For single day jobs, show all photos. This is to address the use
    // case when such a job changes its date.
    if (this.isSingleDay) {
      firebase.database()
        .ref(this.getPhotosListDbPath())    
        .on('value', this.onUpdate)
    }
    else {
      // Only query photos for the day being.
      firebase.database()
        .ref(this.getPhotosListDbPath())
        .orderByChild('jobDateStr')
        .equalTo(this.props.dateStr)
        .on('value', this.onUpdate)
    }
  }

  componentWillUnmount() {
    if (this.isSingleDay) {
      firebase.database()
        .ref(this.getPhotosListDbPath())
        .off('value', this.onUpdate)
    }
    else {
      firebase.database()
        .ref(this.getPhotosListDbPath())
        .orderByChild('jobDateStr')
        .equalTo(this.props.dateStr)
        .off('value', this.onUpdate)
    }
  }

  onUpdate = snapshot => {
    let value = []
    snapshot.forEach(childSnapshot => {
      const child = childSnapshot.val()
      const photo = Object.assign({}, {dbKey: childSnapshot.key}, child)
      if (!photo.delete){
        value.push(photo)
      }
    })
    value.reverse()
    this.setState({ photos: value })
  }

  getPhotosListDbPath = () => {
    return `${this.getExtendedModulesDbPath()}/list`
  }

  getPhotoDbPath = (key) => {
    return `${this.getPhotosListDbPath()}/${key}`
  }

  getImageDbPath = (key) => {
    return `${this.getPhotoDbPath(key)}/image.jpg`
  }

  onAddPhoto = (event, file, result, turnLoadOff) => {
    if (!file) {
      return
    }
    const dbList = firebase.database().ref(this.getPhotosListDbPath())
    const key = dbList.push().key
    const imageDbPath = this.getImageDbPath(key)
    const serverTimestamp = firebase.database.ServerValue.TIMESTAMP
    firebase.storage()
      .ref(imageDbPath)
      .put(file)
      .then(() => {
        dbList.child(key)
          .set({
            name: file.name,
            type: file.type,
            timestamp: serverTimestamp,
            jobDateStr: this.props.dateStr,
            creationDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            dbPath: imageDbPath,
            userId: this.props.userMetadata ? this.props.userMetadata.id : ''
          })
          .then(() => turnLoadOff())
      })
  }

  onImagePress = (selectedIdx) => {
    this.setState({ fullscreenVisible: true, selectedIdx })
  }

  onSlideShowClose = () => {
    this.setState({ fullscreenVisible: false})
  }

  getPhotosViews = () => {
    const views = []
    const size = 74
    views.push(
      <PhotosAddItem
        key={'Add'}
        onAdd={this.onAddPhoto}
        width={size}
        height={size} />
    )
    this.state.photos
      .forEach((photo,idx) => {
        views.push(
          <PhotoItem
            key={idx}
            dbPath={this.getPhotoDbPath(photo.dbKey)}
            storagePath={photo.dbPath}
            photo={photo}
            width={size}
            height={size}
            onPress={this.onImagePress.bind(this, idx)} />
        )
      })
    return views
  }

  render() {
    const views = this.getPhotosViews()
    return (
      <div style={styles.container}>
        { views }
        <PhotoSlideShow
          visible={this.state.fullscreenVisible}
          index={this.state.selectedIdx}
          photos={this.state.photos}
          photosListDbPath={this.getPhotosListDbPath()}
          onClose={this.onSlideShowClose}/>
        <AllPhotosScreen
          open={this.props.openShowAllPhotosScreen}
          jobName={this.props.jobInfo.modules.displayName.value}
          photosListDbPath={this.getPhotosListDbPath()}
          onRequestClose={this.props.onRequestClose}/>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto'
  }
}

const mapStateToProps = state => ({ userMetadata: state.firebase.user.metadata.value })

export default connect(mapStateToProps)(PhotosModule)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/photos/PhotosModule.js